import {Calendar} from '@crema/modules/thirdParty';

export default Calendar;
